(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-faq"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.sn-faq__trigger');
    if (!trigger) return;

    const section = trigger.closest('.sn-faq');
    if (!section) return;

    const item = trigger.closest('.sn-faq__item');
    const isOpen = item.classList.contains('is-open');

    for (const openItem of section.querySelectorAll('.sn-faq__item.is-open')) {
      openItem.classList.remove('is-open');
      const openTrigger = openItem.querySelector('.sn-faq__trigger');
      if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
    }

    if (!isOpen) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-sn-header]');
    if (!header) return;

    const drawer = header.querySelector('.sn-header__drawer');
    const toggle = header.querySelector('.sn-header__toggle');
    const closeBtn = header.querySelector('.sn-header__drawer-close');
    const backdrop = header.querySelector('.sn-header__drawer-backdrop');
    const headerGroup = document.querySelector('#header-group');

    function setHeaderMetrics() {
      const groupHeight = headerGroup ? headerGroup.offsetHeight : header.offsetHeight;
      document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
      document.body.style.setProperty('--header-group-height', `${groupHeight}px`);
    }

    function setScrolled() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }

    function openDrawer() {
      drawer.hidden = false;
      header.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        if (!header.classList.contains('is-open')) drawer.hidden = true;
      }, 380);
    }

    toggle?.addEventListener('click', function () {
      if (header.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });

    closeBtn?.addEventListener('click', closeDrawer);
    backdrop?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-open')) closeDrawer();
    });

    header.querySelectorAll('[data-sn-anchor]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        const href = link.getAttribute('href') || '';
        const hash = href.includes('#') ? href.slice(href.indexOf('#')) : '';
        const target = hash ? document.querySelector(hash) : null;
        if (!target) return;

        event.preventDefault();
        closeDrawer();

        const scroller = document.scrollingElement || document.documentElement;
        const offset = (headerGroup?.offsetHeight || header.offsetHeight) + 8;
        scroller.scrollTop = target.getBoundingClientRect().top + scroller.scrollTop - offset;

        if (history.replaceState) history.replaceState(null, '', hash);
      });
    });

    setHeaderMetrics();
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
    window.addEventListener('resize', setHeaderMetrics);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-product-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class SnProductStory extends HTMLElement {
      connectedCallback() {
        this.model = this.querySelector('[data-prod-speaker]');
        this.scenes = this.querySelectorAll('[data-scene]');
        this.dots = this.querySelectorAll('[data-dot]');
        this.specs = this.querySelector('[data-prod-specs]');
        this.callouts = this.querySelectorAll('[data-callout]');
        this.views = this.querySelectorAll('.sn-spk__view');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scene = 0;
        this.dragging = false;
        this.powerOn = false;
        this.drag = { x: 0, y: 0, rx: 8, ry: -16 };
        this.onScroll = this.onScroll.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        if (this.reduced) {
          this.dataset.reduced = 'true';
          this.querySelectorAll('.sn-prod__scene').forEach(function (el) {
            el.classList.add('is-on');
          });
          this.specs?.classList.add('is-on');
          this.showView('iso');
          this.bindButtons();
          return;
        }

        this.bindButtons();
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.jumpTo(Number(dot.dataset.dot)));
        });
        this.model?.addEventListener('pointerdown', this.onPointerDown);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      bindButtons() {
        this.querySelectorAll('[data-spk-btn]').forEach((btn) => {
          const trigger = () => {
            btn.classList.add('is-pressed');
            window.setTimeout(() => btn.classList.remove('is-pressed'), 160);
            if (btn.dataset.spkBtn === 'power') {
              this.powerOn = !this.powerOn;
              this.classList.toggle('is-on', this.powerOn);
            }
          };
          btn.addEventListener('click', trigger);
          btn.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              trigger();
            }
          });
        });
      }

      onPointerDown(event) {
        if (event.target.closest('[data-spk-btn]')) return;
        this.dragging = true;
        this.drag.x = event.clientX;
        this.drag.y = event.clientY;
        this.model.setPointerCapture(event.pointerId);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        this.drag.x = event.clientX;
        this.drag.y = event.clientY;
        this.drag.ry = Math.max(-40, Math.min(40, this.drag.ry + dx * 0.18));
        this.drag.rx = Math.max(-18, Math.min(22, this.drag.rx - dy * 0.12));
        this.style.setProperty('--sn-prod-ry', this.drag.ry + 'deg');
        this.style.setProperty('--sn-prod-rx', this.drag.rx + 'deg');
      }

      onPointerUp() {
        this.dragging = false;
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
      }

      progress() {
        const rect = this.getBoundingClientRect();
        const total = this.offsetHeight - window.innerHeight;
        if (total <= 0) return 0;
        return Math.min(1, Math.max(0, -rect.top / total));
      }

      onScroll() {
        if (this.dragging) return;
        const p = this.progress();
        const frame = this.frameAt(p);
        this.style.setProperty('--sn-prod-rx', frame.rx + 'deg');
        this.style.setProperty('--sn-prod-ry', frame.ry + 'deg');
        this.style.setProperty('--sn-prod-rz', frame.rz + 'deg');
        this.style.setProperty('--sn-prod-scale', String(frame.scale));
        this.style.setProperty('--sn-prod-explode', frame.explode + 'px');
        this.drag.rx = frame.rx;
        this.drag.ry = frame.ry;
        this.showView(frame.view);
        this.setScene(frame.scene);
        this.classList.toggle('is-night', frame.night);
        this.classList.toggle('is-waves', frame.waves);
        if (frame.power) {
          this.powerOn = true;
          this.classList.add('is-on');
        }
        this.specs?.classList.toggle('is-on', frame.specs);
        this.callouts.forEach((el) => {
          el.classList.toggle('is-on', frame.callouts.includes(el.dataset.callout));
        });
      }

      frameAt(p) {
        const keys = [
          { p: 0, scene: 0, view: 'iso', rx: 10, ry: -22, rz: -6, scale: 0.84, explode: 0, night: false, waves: false, power: false, specs: false, callouts: [] },
          { p: 0.08, scene: 0, view: 'iso', rx: 8, ry: -16, rz: -4, scale: 1, explode: 0, night: false, waves: false, power: false, specs: false, callouts: [] },
          { p: 0.16, scene: 1, view: 'iso', rx: 6, ry: -12, rz: -2, scale: 1.05, explode: 0, night: false, waves: false, power: false, specs: false, callouts: ['thin', 'weight'] },
          { p: 0.26, scene: 2, view: 'top', rx: 0, ry: 0, rz: 0, scale: 1.12, explode: 0, night: false, waves: false, power: false, specs: false, callouts: ['fabric'] },
          { p: 0.36, scene: 3, view: 'side', rx: 0, ry: 0, rz: 0, scale: 1.18, explode: 0, night: false, waves: false, power: false, specs: false, callouts: ['thin'] },
          { p: 0.46, scene: 4, view: 'iso', rx: 8, ry: 18, rz: 2, scale: 1.38, explode: 0, night: false, waves: false, power: true, specs: false, callouts: ['power'] },
          { p: 0.56, scene: 5, view: 'iso', rx: 4, ry: 26, rz: 4, scale: 1.22, explode: 0, night: false, waves: false, power: true, specs: false, callouts: ['port'] },
          { p: 0.66, scene: 6, view: 'iso', rx: 8, ry: -10, rz: -2, scale: 1.08, explode: 0, night: true, waves: true, power: true, specs: false, callouts: ['private'] },
          { p: 0.76, scene: 7, view: 'iso', rx: 12, ry: -18, rz: -4, scale: 0.9, explode: 18, night: false, waves: false, power: false, specs: true, callouts: [] },
          { p: 0.88, scene: 8, view: 'iso', rx: 8, ry: -16, rz: -3, scale: 1, explode: 0, night: false, waves: false, power: true, specs: false, callouts: [] },
          { p: 1, scene: 8, view: 'iso', rx: 8, ry: -16, rz: -3, scale: 1, explode: 0, night: false, waves: false, power: true, specs: false, callouts: [] }
        ];
        let a = keys[0];
        let b = keys[keys.length - 1];
        for (let i = 0; i < keys.length - 1; i += 1) {
          if (p >= keys[i].p && p <= keys[i + 1].p) {
            a = keys[i];
            b = keys[i + 1];
            break;
          }
        }
        const t = b.p === a.p ? 0 : (p - a.p) / (b.p - a.p);
        const e = t * t * (3 - 2 * t);
        return {
          scene: t < 0.5 ? a.scene : b.scene,
          view: t < 0.45 ? a.view : b.view,
          rx: a.rx + (b.rx - a.rx) * e,
          ry: a.ry + (b.ry - a.ry) * e,
          rz: a.rz + (b.rz - a.rz) * e,
          scale: a.scale + (b.scale - a.scale) * e,
          explode: a.explode + (b.explode - a.explode) * e,
          night: t < 0.5 ? a.night : b.night,
          waves: t < 0.5 ? a.waves : b.waves,
          power: a.power || b.power,
          specs: t < 0.5 ? a.specs : b.specs,
          callouts: t < 0.5 ? a.callouts : b.callouts
        };
      }

      showView(name) {
        this.views.forEach((view) => {
          view.classList.toggle('is-on', view.dataset.view === name);
        });
      }

      setScene(index) {
        if (this.scene === index) return;
        this.scene = index;
        this.scenes.forEach((scene) => {
          scene.classList.toggle('is-on', Number(scene.dataset.scene) === index);
        });
        this.dots.forEach((dot) => {
          dot.classList.toggle('is-on', Number(dot.dataset.dot) === index);
        });
      }

      jumpTo(index) {
        const start = this.getBoundingClientRect().top + window.scrollY;
        const total = this.offsetHeight - window.innerHeight;
        const stops = [0, 0.12, 0.22, 0.32, 0.44, 0.54, 0.64, 0.74, 0.9];
        const y = start + total * (stops[index] || 0);
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    if (!customElements.get('sn-product-story')) {
      customElements.define('sn-product-story', SnProductStory);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
